import confirm from '../../../utils/confirm.jsx';
import addError from '../../../utils/error.jsx';

const INDEFINITE = 9999;

export function request(id, period) {
    id = parseInt(id, 10);

    const message = (period == INDEFINITE) ? 
        'Are you sure that you want to self exclude customer indefinitely?' :
        `Are you sure that you want to self exclude customer for ${period} months?`;

    return confirm(message, {
        type: 'CUSTOMERS_SELF_EXCLUSION_REQUEST',
        period,
        id
    });
}

export function error(id, errors) {
    id = parseInt(id, 10);

    addError(errors);

    return {
        type: 'CUSTOMERS_SELF_EXCLUSION_ERROR',
        errors,
        id
    };
}

export function finish(id, customer) {
    return {
        type: 'CUSTOMERS_SELF_EXCLUSION_FINISH',
        customer,
        id
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_SELF_EXCLUSION_CLEAR'
    };
}
